/* global axios */
import ApiClient from '../ApiClient';

class PilotAvailableInboxes extends ApiClient {
  constructor() {
    super('pilot/available_inboxes', { accountScoped: true });
  }
}

export default new PilotAvailableInboxes();
